module.exports = __webpack_public_path__ + "img/songwriters-journal_B09MYW1C9D.7198160f.jpg";